<template>
  <div class="dayNutls" v-loading="Delectloading" :element-loading-text="textContent">
    <div class="serchest">
      <el-input :placeholder="dataobjs.qingshuruneirong" v-model="input3" style="width:30%;">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="btnes">
        <el-button type="primary" plain @click="myaddData">{{dataobjs.xinzeng}}</el-button>
      </div>
    </div>
    <div class="tablt">
        <el-table
      :data="tabbData"
      stripe
      style="width:100%"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      border
    >
      <el-table-column :label="dataobjs.lanmuming" :show-overflow-tooltip="true" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.title}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="dataobjs.lanmumingyingwen" :show-overflow-tooltip="true" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.title_en }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="dataobjs.fangwenlujing"
        :show-overflow-tooltip="true"
        align="center"
        width="120"
        prop="path"
      ></el-table-column>
      <el-table-column :label="dataobjs.xianshiyangshi" :show-overflow-tooltip="true" align="center">
        <template slot-scope="scope">
          <i :class="scope.row.icon"></i>
        </template>
      </el-table-column>
      <el-table-column :label="dataobjs.yonghuquanxianleixing" :show-overflow-tooltip="true" align="center">
        <template slot-scope="scope">
          <!-- {{scope.row.roletype}} -->
          <span
            v-for="(item,index) in scope.row.roletype.split(',')"
            :key="index"
          >{{item == 0 ?'平台' :''+item == 1?'经销商':''+item==2?'客户':''}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="dataobjs.caozuo" :show-overflow-tooltip="true" align="center">
        <template slot-scope="{row}">
          <el-button size="mini" @click="editFrom(row)" round icon="el-icon-edit" type="primary">{{dataobjs.xiugai}}</el-button>
          <el-button size="mini" type="danger" @click="deleData(row)" icon="el-icon-delete" round>{{dataobjs.shanchu}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <page-helper :page-data="pageData" :total="total" :get-table-list="userList"></page-helper>
    </div>
    <!-- 对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="45%"
      :modal="false"
      :before-close="handleClose"
    >
      <add
        :optiones="optiones"
        :rule-form="ruleForm"
        :navleftnew="NavLeftNet"
        :hidechide="hidechide"
        :user-list="userList"
        ref="uAddlist"
        :dataobjs="dataobjs"
      />
    </el-dialog>
  </div>
</template>
<script>
import { getdataListName, NavLeft, dealerDelete ,lang_fend} from "@/network/index";
import { setTimeout } from "timers";
import PageHelper from "@/components/common/PageHelper";
import add from "./components/add";
export default {
  components: {
    PageHelper,
    add,
  },
  data() {
    return {
      arrList: [],
      ruleForm: {
        title: "",
        title_en: "",
        path: "",
        icon: "",
        roletype: "",
        parentid: "",
        uud: "",
      },
         lang_file: sessionStorage.getItem("lang_file"),
      input3: "",
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30, //数据   pagesize几条数据
      },
      dialogVisible: false,
      tabbData: [],
      treedata: [],
      Delectloading: false, //加载图表
      textContent: "正在努力加载中...", //加载提示文字
      total: null,
      optiones: [],
      title: "",
      dataobjs:{}
    };
  },
  mounted() {
    // let arr = 1,2,3

    this.userList();
    this.NavLeftNet();
    this.lang_fend()
  },
  methods: {
    // 翻译
    async lang_fend() {
      let page = "userright_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      console.log(data);
      
      this.dataobjs = data;
    },
    //修改
    editFrom(e) {
      this.title = "修改权限信息";
      // console.log(e.roletype);
      // this.arrList = e
      console.log(e.roletype.split(","));

      this.$nextTick(() => {
        // console.log();
        this.$refs.uAddlist.checkedCities = e.roletype.split(",");
      });
      this.dialogVisible = true;
      this.ruleForm = {...e};
    },
    handleClose() {
      this.ruleForm = {};
      this.$refs.uAddlist.checkedCities = [];
      this.dialogVisible = false;
    },
    // 关闭子组件的方法
    hidechide() {
      this.dialogVisible = false;
    },
    // 下拉框数据
    async NavLeftNet() {
      const { data } = await NavLeft();
      // console.log(data);
      this.optiones = data;
    },
    // 新增数据
    myaddData() {
      this.title = "新增权限信息";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.ruleForm = {};
      });
    },
    //获取用户列表
    async userList() {
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      const { code, data, msg } = await NavLeft(pagenum, pagesize);

      this.total = Number(data.pagelist[0].allrow);
      if (data.list != "") {
        this.tabbData = data.list;
        this.Delectloading = false;
      }

      // if (code) {
      //   this.tabbData = data;
      //   this.Delectloading = false;
      // } else {
      //   this.Delectloading = false;
      //   this.$message.error(msg);
      // }
    },
    //删除数据
    deleData(e) {
      this.$confirm(`${this.dataobjs.tishixinxi}`, `${this.dataobjs.tishi}`, {
        confirmButtonText: `${this.dataobjs.queding}`,
        cancelButtonText: `${this.dataobjs.quxiao}`,
        closeOnClickModal: false,
        type: "warning",
      })
        .then(async () => {
          let tablename = "tb_system_authority";
          const { code, data, msg } = await dealerDelete(e.uuid, tablename);
          if (code) {
            this.userList();
            this.NavLeftNet();
            this.$message({
              type: "success",
            message:`${this.dataobjs.shanchuchenggong}`,
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message:`${this.dataobjs.yiquxiaoshanchu}`,
          });
        });
    },
    // 查询
    addContent() {},
    deiName() {},
  },
};
</script>
<style scoped>
.dayNutls {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.serchest {
  width: 100%;
  display: flex;
}
.tablt{
  height: 200px;
}
</style>
